import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlusBoxStack16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPlusBoxStack16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1V5a2 2 0 0 0-2-2H4a1 1 0 0 1 1-1m10 9a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2 2 2 0 0 1 2-2h8a2 2 0 0 1 2 2zM3 4h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m3.917 2.278a.5.5 0 0 1 .5.5v1.639h1.805a.5.5 0 1 1 0 1H7.417v1.805a.5.5 0 1 1-1 0V9.417h-1.64a.5.5 0 0 1 0-1h1.64v-1.64a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlusBoxStack16);
